import { create } from 'zustand';
import { Mileage, TypeOfLeasing } from '../types';

export type SettingsStore = {
  typeOfLeasing: TypeOfLeasing;
  mileage: Mileage;
  workMileage: number;
  firstRent: boolean;
  fuelBenefit: boolean;
  interestRate: number;
  gasPricePerLiter: number;
  electricityPricePerKwh: number;
  percentOnElectricity: number;
  percentTaxRate: number;
  updateSettingsStore: (state: Partial<SettingsStore>) => void;
};

const useSettingsStore = create<SettingsStore>()((set) => ({
  typeOfLeasing: TypeOfLeasing.BUSINESS,
  mileage: 1500,
  workMileage: 100,
  firstRent: true,
  interestRate: 7.95,
  fuelBenefit: false,
  gasPricePerLiter: 18,
  electricityPricePerKwh: 3,
  percentOnElectricity: 0.7,
  percentTaxRate: 0.5,
  updateSettingsStore: (state) => set(state),
}));

export default useSettingsStore;
